import * as React from "react";
import { Badge } from "reactstrap";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { LanguageSelector } from "@/components/LanguageSelector";
import { ProfilePicture } from "@/components/ProfilePicture";
import { UserNameBloc, UserProfileBloc } from "@/components/UserProfileBloc";
import { WORKSHOP_PATH } from "@/config/settings";
import { useAuth } from "@/context/AuthContext";
import { CartContext } from "@/context/CartItems";

const CartButton = (): JSX.Element => {
    const { cart } = React.useContext(CartContext);
    return (
        <a
            href={`${WORKSHOP_PATH}/cart`}
            className="cart-link"
            target="_blank"
            rel="noreferrer"
        >
            <FontAwesomeIcon icon={faShoppingCart} />
            {cart.length > 0 && <Badge pill>{cart.length}</Badge>}
        </a>
    );
};

type Props = {
    reduced: boolean;
};

export const UserPictureAndName = ({ reduced }: Props): JSX.Element => {
    const { userInfo } = useAuth();

    return (
        <UserProfileBloc reduced={reduced}>
            <ProfilePicture />
            <UserNameBloc>
                <span className="ms-4 me-2">{userInfo.name}</span>
                <CartButton />
                <LanguageSelector className="me-2" />
            </UserNameBloc>
        </UserProfileBloc>
    );
};
